<template>
  <vs-row>
    <vs-col vs-w="12">
      <div class="widget-card-header-style">{{ title | capitalize }}</div>
    </vs-col>
    <vs-col vs-type="flex" vs-justify="flex-end" vs-w="3">
      <slot></slot>
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
}
</script>

<style>
.widget-card-header-style {
  font-size: 1.8em;
  width: 95%;
  font-weight: bold;
}
</style>